import request from '../../api/request';

export const getFormStructure = (url: string) => {
  return request(url);
};
